import { Redirect, useLocalSearchParams } from 'expo-router';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const params = useLocalSearchParams<{ orderId: string }>();

  return (
    <Redirect withAnchor href={{ pathname: '/account/gift/confirmation/[orderId]', params }} />
  );
}
